import React, { PropTypes } from 'react';
import { Link } from 'react-router';

import logo from '../assets/images/logo.png';

const Header = ({ profile, actions, brand }) => (
    <div className="header">
        <div className="head-sponsor-left">
            <div className="strip" />
            <a href={brand.website}>
                <img src={brand.logo} alt={brand.name} />
            </a>
        </div>

        <div className="head-sponsor" style={{ background: brand.primary_color }}>
            <div className="container">
                <div className="col-md-4 col-sm-6 col-xs-23 message">
                    <span>Proudly sponsored by <a href={brand.website} target="_blank" rel="noopener noreferrer">{brand.name}</a></span>
                </div>
                {profile.isLoggedIn ?
                    <div className="col-md-8 col-sm-6 col-xs-12 user-details">
                        <div className="dropdown" style={{ display: 'inline-block' }}>
                            <a
                                data-target="#"
                                href="#"
                                id="dLabel"
                                data-toggle="dropdown"
                                role="button"
                                aria-haspopup="true"
                                aria-expanded="false">
                                Welcome {profile.displayName} <i className="fa fa-chevron-down" />
                            </a>
                            <ul className="dropdown-menu" aria-labelledby="dLabel">
                                <li><Link to="/profile/update">Update profile</Link></li>
                                {profile.isSchool ? <li><Link to="/add-users">Invite parents</Link></li> : <li><Link to="/invite">Invite</Link></li>}
                                {/* profile.isSchool ? <li><Link to="/resources/manage">Manage resources</Link></li> : null */}
                                <li><Link to="/profile/settings">Settings</Link></li>
                                <li><a onClick={actions.logoutRequest}>Log out</a></li>
                            </ul>
                        </div>
                    </div>
                : null}
            </div>
        </div>

        <div className="nav-spacer" />

        <nav className="navbar navbar-1">
            <div className="navigation container">
                <div className="navbar-header">
                    <div className="navbar-brand">
                        <Link to="/"><img src={logo} alt="" /></Link>
                    </div>
                    <button type="button" data-toggle="collapse" data-target=".myNavbar" className="navbar-toggle">
                        <span className="src-only" /><i className="fa fa-bars" />
                    </button>
                </div>

                <div className="myNavbar collapse navbar-collapse">
                    {profile.isLoggedIn ?
                        <ul className="nav navbar-nav navbar-right">
                            <li className="menu-item">
                                <Link className="selected" to="/resources">Resources</Link>
                            </li>
                            <li className="menu-item">
                                <a className="selected" href="http://clevertykes.com/shop/" target="_blank">Shop</a>
                            </li>
                            <li className="menu-item">
                                <Link className="selected" to="/contact">Contact</Link>
                            </li>
                            {profile.isSchool ?
                                <li className="menu-item" id="book-session">
                                    <Link className="selected" to="/book-session">Book Enterprise Session</Link>
                                </li>
                                : null}
                        </ul>
                    :
                        <ul className="nav navbar-nav navbar-right">
                            <li className="menu-item">
                                <Link className="selected" to="/login">Log in</Link>
                            </li>
                            <li className="menu-item">
                                <Link className="selected" to="/register">Register</Link>
                            </li>
                            <li className="menu-item">
                                <Link className="selected" to="/contact">Contact</Link>
                            </li>
                        </ul>
                    }
                </div>
            </div>
        </nav>
    </div>
);

Header.propTypes = {
    profile: PropTypes.object,
    actions: PropTypes.object,
    brand: PropTypes.object,
};

export default Header;



/** WEBPACK FOOTER **
 ** ./src/components/Header.js
 **/